import "./noktypes.scss"

export default function Noktypes() {
    const nokTypesData = [
        {
            id : 1,
            img : 'assets/typeBg01.png',
            nokImg : 'assets/Nok01.png',
            title:'GOLD',
            balance:5
        },
        {
            id : 2,
            img : 'assets/typeBg02.png',
            nokImg : 'assets/Nok02.png',
            title:'RUBY',
            balance:4070
        },
        {
            id : 3,
            img : 'assets/typeBg03.png',
            nokImg : 'assets/Nok05.png',
            title:'MOON',
            balance:2500
        },
        {
            id : 4,
            img : 'assets/typeBg04.png',
            nokImg : 'assets/Nok04.png',
            title:'CLAY',
            balance:1175
        },
        {
            id : 5,
            img : 'assets/typeBg05.png',
            nokImg : 'assets/Nok03.png',
            title:'MYST',
            balance:1800
        },
        {
            id : 6,
            img : 'assets/typeBg06.png',
            nokImg : 'assets/Nok06.png',
            title:'BRONZE',
            balance:450
        },
        {
            id : 7,
            img : 'assets/typeBg07.png',
            nokImg : 'assets/covidNok.png',
            title:'COVID',
            balance:450
        }
    ]
    return (
        <div className="noktypes" id="#gallery">
            <div className="noktypesTitle">
                <h1>NOK TYPES (RARITY)</h1>
            </div>
            <div className="noktypesContent">
                {
                    nokTypesData.map((d) =>(
                        <div className="typesItem" key = {d.id}>
                            <div className="itemImg">
                                <img className="itemImgBg" src={d.img} alt="" />
                                <img className="itemImgBluer" src="assets/Rectangle 955496.png" alt="" />
                                <img className="itemNokImg" src={d.nokImg} alt="" />
                            </div>
                            <div className="typeName">{d.title}</div>
                        </div>
                    )
                )}
            </div>
        </div>
    )
}
